import {createFileRoute} from '@tanstack/react-router'
import CoachesList from "../../../../components/coaches/CoachesList.tsx";
import Content from "../../../../components/Content.tsx";
import Header from "../../../../Header.tsx";

export const Route = createFileRoute('/_app/organizer/coaches/')({
    component: RouteComponent,
    staticData: {
        backUrl: '/organizer/assessments',
    }
})

function RouteComponent() {
    return <>
        <Header />

        <Content>
            <CoachesList />
        </Content>
    </>
}
